export default "__VITE_ASSET__BmO8BjBG__"